import { EquiposLayout } from "../equipos/EquiposLayout";
// import { NavBar } from "../ui/NavBar";


export const DashboardRoutes = () => {
    return (
        <>
            {/* <NavBar /> */}
            <EquiposLayout />
            
        </>
    );
}